<template>
  <div>
    <header class="header">
      <div class="header-left">
        <a style="height: 52px; display: block; color: #cca352; text-decoration: none; font-size: 30px; line-height: 67px; margin-left: 19px; font-weight: 700">{{ $t('vip.level') }}</a>
        <!-- <a style="height: 52px; display: block; color: #cca352; text-decoration: none; font-size: 30px; line-height: 67px; margin-left: 19px; font-weight: 700">
          {{$store.state.userInfo.current_vip ? $store.state.userInfo.current_vip :''}}
        </a> -->
      </div>
      <div class="top-right">
        <div class="user-login" v-if="$store.state.token">
          <a @click="$parent.goNav('/')">{{ $t('header.home') }} </a> &nbsp;|&nbsp;
          <a class="shiwan" @click="$parent.goNav('/mine/center')">{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }}</a>
          &nbsp;|&nbsp; <a @click="outLogin">{{ $t('header.Signout') }}</a>
        </div>
        <div class="user-login" v-else>
          <a @click="$parent.goNav('/')"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('header.home') }}</font></font
            ></a
          ><font style="vertical-align: inherit"
            ><font style="vertical-align: inherit"> &nbsp;| </font><font style="vertical-align: inherit">{{ $t('header.Notmember') }} </font></font
          ><a @click="$parent.goNav('/register')"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('header.register') }}</font></font
            ></a
          >
        </div>
      </div>

      <img style="margin-top: -48px" class="header-logo" src="/static/image/logo1-1.png" />
    </header>
    <div class="app-content view-slideup on">
      <div data-v-9e197730="" data-v-011e1fb8="" class="nationalClub mainContent top50">
        <div class="_35lz77bA" v-if="$store.state.token" style="padding-top: 25px">
          <div class="_24vddGqv">
            <div class="_3LPqql-T">
              <!-- <div class="_1T9MY2MW"><img class="NO9x7T89" src="/static/image/my_vip_v-36b4.png?PageSpeed=off" /></div> -->
              <section>
                <div class="_3EUFt5Wv" >
                  <div class="_29gnuiyG" style="margin: 36px 0px 37px">
                    <div class="_35_vygsc">
                      <h1 :style=" $i18n.locale == 'zh' ? 'margin-top: 0px':'margin-top: 0px;font-size:24px!important'">{{ $t('vip.conditions') }}</h1>
                    </div>
                    <div class="_2zJiZW9W"></div>
                  </div>
                  <div class="_3VD5zTpM">
                    <div class="_2szQExG9">
                      <img
                        class="_1nSvFFDr"
                        src="data:image/png;base64,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"
                      />
                      <div class="_3d_hDAu4">
                        <div class="_15yexfD5">{{ $t('vip.running') }}</div>
                        <div class="_3cIZGfn2" id="n1"><span>￥</span></div>
                      </div>
                    </div>
                    <div class="_2szQExG9">
                      <img class="_1nSvFFDr" src="/static/image/vip_promotion_2_icon-4840.png" />
                      <div class="_3d_hDAu4">
                        <div class="_15yexfD5">{{ $t('vip.recharge') }}</div>
                        <div class="_3cIZGfn2" id="n2"><span>￥</span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="_29gnuiyG" style="margin: 94px 0px 13px">
                  <div class="_35_vygsc">
                    <h1 :style=" $i18n.locale == 'zh' ? 'margin-top: 0px':'margin-top: 0px;font-size:24px!important'">{{ $t('vip.water') }}</h1>
                  </div>
                  <div class="_2zJiZW9W"></div>
                </div>
                <ul class="_1qdtjegd item1" style="display: flex;">
                  <li class="sWAv_g1H" style="flex:1">
                    <div>{{ $t('vip.level') }}</div>
                    <div>{{ $t('vip.CASINO') }}</div>
                    <div>{{ $t('vip.SLOTS') }}</div>
                    <div>{{ $t('vip.CARD') }}</div>
                    <div>{{ $t('vip.SPORTS') }}</div>
                    <div>{{ $t('vip.LOTTERY') }}</div>
                    <div>{{ $t('vip.ESPORT') }}</div>
                  
                  </li>
                  <li class="" v-for="(item, index) in vipLis" :key="index" v-if="item.status == 1 " style="flex:1">
                    <img src="/static/image/vip_icon_5_bright-4a8c.png" />
                    <div class="-p-khenT">{{ item.vipname }}</div>
                    <div>{{ item.realperson }}%</div>
                    <div>{{ item.electron }}%</div>
                    <div>{{ item.joker }}%</div>
                    <div>{{ item.sport }}%</div>
                    <!-- <div>{{ item.fish }}%</div> -->
                    <div>{{ item.lottery }}%</div>
                    <div>{{ item.e_sport }}%</div>
                  </li>
                </ul>
                <div class="_36tYfDFP" style="display: none">注：以上为BOB自研场馆（包含博雅棋牌）、OB体育、FB体育、AG真人最高返水比例，具体返水金额请以实际游戏为准，其它疑问请联系7*24在线客服咨询。</div>

                <div class="_29gnuiyG" style="margin: 100px 0px 60px; display: none">
                  <div class="_35_vygsc">
                    <h1 style="margin-top: 0px">条款和规则</h1>
                  </div>
                  <div class="_2zJiZW9W"></div>
                </div>
                <div class="_6M6n3DaL" style="display: none">
                  <div>
                    <h1>晋升标准</h1>
                    <p>会员的累计有效投注额达到相应级别的要求，即可在次日24点前晋级相应VIP等级。</p>
                    <h1>晋升顺序</h1>
                    <p>VIP等级达到相应的要求可每天晋升1级，但VIP等级不可越级晋升。</p>
                    <h1>保级要求</h1>
                    <p class="MsoNormal">会员在达到某VIP等级时刻起计算，每90天内投注需要完成保级要求。如果在此期间完成晋升，保级要求从新按照当前等级计算。</p>
                    <h1>降级标准</h1>
                    <p>如果会员在一个季度（90天计算）内没有完成相应的保级要求流水，系统会自动降级一个等级，相应的返水及其它优惠也会随之调整至降级后的等级。</p>
                    <h1>特别优惠</h1>
                    <p class="MsoNormal">
                      达到相应等级的VIP会员可点击折换彩金按钮，系统将在5分钟内添加对应彩金至中心钱包内，仅需3倍流水即可出款，每个级别的彩金每位会员仅能获得1次。BOB体育对折换彩金拥有最终解释权。（名贵礼品折换彩金仅针对VIP6/VIP7/VIP8/VIP9/VIP10）会员，请会员在达到对应VIP等级后及时领取，若升级到下一等级VIP后前一等级VIP豪礼折现彩金未领取，则视为放弃该彩金。
                    </p>
                    <h1>升级礼金</h1>
                    <p>升级礼金在会员达到该会员级别后通过VIP详情页面进行自助领取，每个级别的升级礼金每位会员仅能获得1次，请在升至下一VIP等级之前及时领取，逾期未领视为放弃。<em>（升级礼金1倍流水即可提款）</em></p>
                    <h1>生日礼金</h1>
                    <p>VIP5或以上等级会员可享受生日礼金，若会员生日在注册时间之后的3个月以内（含3个月），则今年将不能领取生日礼金。若会员生日在注册时间之后的三个月以外，则可以在生日当天通过VIP详情页面进行自助领取，每年仅可领取一次。<em>（生日礼金1倍流水即可提款）</em></p>
                    <p></p>
                    <h1>每周红包</h1>
                    <p class="MsoNormal">会员可根据上一周有效流水（周一0点至周日23点59分59秒）与VIP等级（以上周周日其所在的VIP等级为准）在活动页面领取每周红包，领取截止时间为自然周每周五24点，过期作废，不可补发。</p>
                    <p class="MsoNormal">彩金仅支持转入BOB体育、OB体育、BOB电竞、BOB真人、BOB棋牌、BOB彩票、BOB电子、BOB捕鱼场馆、博雅棋牌 。仅需满足对应场馆流水要求即可解锁。</p>
                    <p>
                      周红包领取时间详情：<br />
                      VIP1-VIP5 开启时间（自然周每周一）01:00—结束时间（自然周每周五）24:00
                    </p>
                    <p>VIP6-VIP10开启时间（自然周每周一）13:00—结束时间（自然周每周五）24:00<br /></p>

                    <p></p>
                    <p></p>
                    <!-- <h1>BOB保留对活动的修改，停止及最终解释权。</h1> -->
                    <p></p>
                    <!-- <h2 class="MsoNormal">每日返水将会在13:30-16:00发放，每日返水总额最低为1元，每日返水总额小数点后将不进行计算，场馆锁定期间流水不参与返水。</h2> -->
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <div class="sponsors"></div>
        <div class="foot-nav">
          <div class="copyright all-rights">© 2022 {{$store.state.appInfo.title}} {{ $t('foot.All') }}. </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'vip',
  data() {
    return { vipLis: [] };
  },
  created() {
    let that = this;
    that.uservip();
  },
  methods: {
    uservip() {
      let that = this;
      that.$apiFun.post('/api/uservip', {}).then(res => {
        if (res.code == 200) {
          that.vipLis = res.data;
          let num = that.$store.state.userInfo.vip * 1;
          console.log(num);
          $('#n1').html(`<span>￥</span>${that.vipLis[num].flow}`);
          $('#n2').html(`<span>￥</span>${that.vipLis[num].recharge}`);
        }
      });
    },
    outLogin() {
      let that = this;
      that.$parent.outLogin();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../static/css/style.css';
@import '../../static/css/bootstrap.min.css';

html,
body {
  font-family: Arial, 'Microsoft JhengHei', sans-serif;
}
label {
  font-weight: 400;
}
.at-content {
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 99;
}
.at-mlu {
  height: 43px;
  color: rgb(255, 242, 155);
  font-size: 17px;
  line-height: 43px;
  width: 170px;
  text-align: center;

  background: url(/mb10/activity/img/xpj_prospirit.png) no-repeat 0px 0px;
  background-size: auto 43px;
}
.at-detail {
  margin: 10px 30px;
  line-height: 26px;
  color: rgb(51, 51, 51);
  font-size: 15px;
}
.at-font-red {
  color: red;
}
input {
  border-style: none;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.box {
  position: relative;
  border-radius: 3px;
  background: #ffffff;
  border-top: 3px solid #e74c3c;
  margin-bottom: 20px;
  width: 100%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  padding: 20px 5%;
  margin-top: 20px;
  width: 500px;
}
.logon-tab {
  color: #666;
  margin-bottom: 10px;
  font-size: 13px;
}
.controls {
  color: #666;
  font-size: 13px;
  margin-top: 15px;
}
.activity-image {
  height: 120px;
  width: auto;
  margin: 0 auto;
  margin-bottom: 12px;
}
@media screen and (max-width: 768px) {
  .at-detail {
    margin: 5px 10px;
  }
  .at-mlu {
    height: 35px;
    line-height: 35px;
    background-size: auto 35px;
    width: 140px;
    font-size: 14px;
  }
}

.table-bordered {
  margin-top: 10px;
}
.at-tr.at-font-red td {
  background: #f5f5f5;
  color: #999;
}
.at-tr {
  text-align: center;
}
.at-title {
  font-size: 30px;
  text-align: center;
  color: #333;
  margin-top: 15px;
}
@media screen and (max-width: 768px) {
  .at-tr td {
    font-size: 13px;
  }
  .at-title {
    font-size: 20px;
  }
  .box {
    width: 100%;
  }
}

.header-logo {
  width: auto;
  height: 55px;
  margin: -55px auto 0 auto;
  display: inherit;
}
.app-content {
  top: 90px;
}
.activity-content {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: #fff;
}
#result {
  font-size: 16px;
  color: #aaa;
}
.activity-sub {
  width: 100%;
  margin: 0 auto;
  border: 1px solid #ba924a;
  border-radius: 5px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  display: -webkit-box;
}
.form-input {
  display: block;
  width: 100%;
  height: 34px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  color: #000;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  padding: 6px 12px;
}
.from-title {
  line-height: 40px;
  color: #ccc;
}
.form-btn {
  margin-top: 30px;
  line-height: 40px;
  height: 40px;
  border-radius: 3px;
  left: 50%;
  margin-left: -95px;
}
.form-group {
  -webkit-box-flex: 1;
  position: relative;
}
.free-demo {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  display: block;
  width: 190px;
  height: 44px;
  float: left;
  text-align: center;
  line-height: 44px;
  background: #cca352;
  position: relative;
  transition: all 0.2s;
  overflow: hidden;
}
.free-dem-a {
  color: #fff;
  font-size: 16px;
}
.free-demo:after {
  content: '';
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(-45deg);
  position: absolute;
  top: -10%;
  left: -100%;
  transition: 0.6s ease;
}
.free-demo:hover {
  background: #ba8d4d;
}
.free-demo:hover:after {
  animation: cv-submit-hover 0.8s ease;
}

@keyframes cv-submit-hover {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.group-content {
  width: 80%;
  max-width: 300px;
  position: absolute;
  right: 0;
}
.activity-image {
  margin-bottom: 5px;
}

.footer {
  margin-top: 100px;
}

html,
body {
  font-family: Arial, 'Microsoft JhengHei', sans-serif;
}
label {
  font-weight: 400;
}
.at-content {
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 99;
}
.at-mlu {
  height: 43px;
  color: rgb(255, 242, 155);
  font-size: 17px;
  line-height: 43px;
  width: 170px;
  text-align: center;
  background: url(/static/image/xpj_prospirit.png) no-repeat 0px 0px;
  background-size: auto 43px;
}
.at-detail {
  margin: 10px 30px;
  line-height: 26px;
  color: rgb(51, 51, 51);
  font-size: 15px;
}
.at-font-red {
  color: red;
}
input {
  border-style: none;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.box {
  position: relative;
  border-radius: 3px;
  background: #ffffff;
  border-top: 3px solid #e74c3c;
  margin-bottom: 20px;
  width: 100%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  padding: 20px 5%;
  margin-top: 20px;
  width: 500px;
}
.logon-tab {
  color: #666;
  margin-bottom: 10px;
  font-size: 13px;
}
.controls {
  color: #666;
  font-size: 13px;
  margin-top: 15px;
}

.activity-image {
  display: block;
}
.activity-image1 {
  display: none;
}

@media screen and (max-width: 768px) {
  .header-logo {
    display: none;
  }

  .app-content {
    top: 60px;
  }
  .image-back {
    top: 45px;
  }
  .activity-image1 {
    width: 100%;
    margin-bottom: 10px;
  }
  .footer {
    margin-top: 70px;
  }
  .at-detail {
    margin: 5px 10px;
  }
  .at-mlu {
    height: 35px;
    line-height: 35px;
    background-size: auto 35px;
    width: 140px;
    font-size: 14px;
  }
  .activity-image {
    display: none;
  }
  .activity-image1 {
    display: block;
  }
}
._35lz77bA,
._35lz77bA ._24vddGqv {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
}
._35lz77bA {
  width: 100%;
  min-height: 100vh;
  -webkit-flex-direction: column;
  flex-direction: column;
  // background-color: #f3f7fa;
  overflow: hidden;
}

._1T9MY2MW {
  width: 100%;
  height: 522px;
  margin: 0 auto;
  background-image: url(/static/image/vip_banner_bg-917c.png);
  background-position: top;
  background-repeat: no-repeat;
  background-size: auto 522px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._1T9MY2MW .NO9x7T89 {
  width: 390px;
  height: auto;
}
._2E6jtCgT {
  height: 123px;
  margin: 0 auto;
}
._2E6jtCgT ._3e4HH8iZ {
  width: 1130px;
  height: 80px;
  margin: 31px auto 0;
  position: relative;
}
._2E6jtCgT ._3e4HH8iZ ._3VRVyqAh {
  position: absolute;
  left: 0;
  top: 37.5px;
  z-index: 50;
  display: block;
  width: 571px;
  height: 2px;
  background-color: #e3e5ed;
  -webkit-transform: rotate(8deg);
  transform: rotate(8deg);
}
._2E6jtCgT ._3e4HH8iZ ._3VRVyqAh div {
  height: 2px;
  width: 100%;
  background: -webkit-linear-gradient(right, #f1c9b8, #cc8666);
  background: linear-gradient(270deg, #f1c9b8, #cc8666);
}
._2E6jtCgT ._3e4HH8iZ ._1lBySHOA {
  position: absolute;
  left: 565px;
  top: 37.5px;
  z-index: 50;
  display: block;
  width: 571px;
  height: 2px;
  background-color: #e7e3dc;
  -webkit-transform: rotate(-8deg);
  transform: rotate(-8deg);
}
._2E6jtCgT ._3e4HH8iZ ._1lBySHOA div {
  height: 2px;
  width: 100%;
  -webkit-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
  background: -webkit-linear-gradient(left, #f1c9b8, #cc8666);
  background: linear-gradient(90deg, #f1c9b8, #cc8666);
}
._2E6jtCgT ._3e4HH8iZ li {
  position: absolute;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  z-index: 100;
  cursor: pointer;
  width: 76px;
  height: 76px;
}
._2E6jtCgT ._3e4HH8iZ li p {
  text-align: center;
  color: #98a3b1;
}
._2E6jtCgT ._3e4HH8iZ li._2JnL_gCG p {
  color: #d7967f;
}
._2E6jtCgT ._3e4HH8iZ li._2WVkXTz5 {
  font-weight: 700;
  font-family: PingFangSC-Semibold -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
}
._2E6jtCgT ._3e4HH8iZ li._2WVkXTz5 p {
  position: relative;
}
._2E6jtCgT ._3e4HH8iZ li._2WVkXTz5 p:before {
  content: ' ';
  position: absolute;
  left: 50%;
  bottom: -12px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 14px;
  height: 14px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADSUExURUxpcf/a2v/czPnTw//b0v/r4fbUx//////////h1PfVxP/ax/fUxfjVxf/WyffZx/nWw//awtORdPbTw/XTwvbUw/XTwvXTw//Wx/bTwvjTw/bVxOm6pfXTw/jWxfbSwuOul/XUw/bTw/jTw/fTxPXTxPHJte3DsOKul/XSwvXSw/XSwvbSxPbSw/XTw9yji/bTwu3CsNicgv////XNvP/9/em5pPbTw////+e2oe/Gs+u/qt+oj9aYfOOvmNughuKvmM+Ka82GZuq+qu7Fs9qghdKNWMAAAAA4dFJOUwAHDy8LBR0BAghCDSEyEhoqFf5yn1mHbBZcRTzVjSWv4FN7SWNPjajWpbe5OZWB8Je/94pnor93mDQ29AAAAV9JREFUeNqlzdlygjAUgOEgBBKQxbKqbIoC7rvTYovW5f1fqQlScFqv2n8yQ5hvTg74e4KANq9P2iBBAAhBuPttOwgRAgjiOMuu2ZWc7KEYQwQglpTkcrgcqsjP5ZIoEoaA4RRe27/9aK/xCscA3FB9uZPmeX7KT+QU37Qj+2oDAzrYHW7D94fC7bBLRymyomnHi9vxdiy6LWLbFFmKuEDdStYfZevE0gvEdKfW7dmWsXopWxmW3etqdCfkWk05GvRngftZ5Aaz/iCSmy0OAliNjt0zyR1XgxAgyN23eqNJeD6Hk5F338hBBAREH2Y7bd0zgjQNDE9vd1j6KBJAqTJRa2kYS4uY/G1UmUJNuz+f922zMIZaqZLTlMVhezBoD0W56Uil1cpOxSgSp2xpNUIstXhfY1nN51sSLhfWyimOyvOqo3CV1Uq4QSJUWa2EGRKhymoViNPIBTxLKOH/fQHMpD2nuvk3bwAAAABJRU5ErkJggg==)
    no-repeat 50%;
  background-size: cover;
}
._2E6jtCgT ._3e4HH8iZ li ._3PpgCJLA {
  display: block;
  border: none;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
._2E6jtCgT ._3e4HH8iZ li ._3PpgCJLA._3W1_25Yq {
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
}
._2E6jtCgT ._3e4HH8iZ li ._3a-pKTMT {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  pointer-events: none;
}
._2E6jtCgT ._3e4HH8iZ li ._3a-pKTMT ._3B6YH0ov {
  opacity: 0.5;
  z-index: -1;
}
._2E6jtCgT ._3e4HH8iZ li ._3a-pKTMT ._3B6YH0ov,
._2E6jtCgT ._3e4HH8iZ li ._3a-pKTMT ._3LMLDUFo {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  display: block;
  border: none;
}
._2E6jtCgT ._3e4HH8iZ li ._3a-pKTMT ._3LMLDUFo {
  z-index: -2;
}
._2E6jtCgT ._3e4HH8iZ li img {
  width: 100%;
  height: 100%;
}
._2E6jtCgT ._3e4HH8iZ li ._3W1_25Yq {
  margin-bottom: 15px;
}
._2E6jtCgT ._3e4HH8iZ li ._3a-pKTMT {
  width: 90px;
  height: 90px;
}
._2E6jtCgT ._3e4HH8iZ li ._3a-pKTMT ._3B6YH0ov {
  width: 90px;
  height: 90px;
  -webkit-animation: x2P9kU6U 2s linear infinite;
  animation: x2P9kU6U 2s linear infinite;
}
._2E6jtCgT ._3e4HH8iZ li ._3a-pKTMT ._3LMLDUFo {
  width: 90px;
  height: 90px;
  -webkit-animation: x2P9kU6U 2s linear 0.3s infinite;
  animation: x2P9kU6U 2s linear 0.3s infinite;
}
._2E6jtCgT ._3e4HH8iZ li p {
  font-size: 16px;
  line-height: 22px;
}
._2E6jtCgT ._3e4HH8iZ li:first-of-type {
  left: 0;
  top: 0;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(2) {
  left: 125px;
  top: 18px;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(3) {
  left: 250px;
  top: 36px;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(4) {
  left: 375px;
  top: 54px;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(5) {
  left: 500px;
  top: 72px;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(6) {
  left: 625px;
  top: 72px;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(7) {
  left: 750px;
  top: 54px;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(8) {
  left: 875px;
  top: 36px;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(9) {
  left: 1000px;
  top: 18px;
}
._2E6jtCgT ._3e4HH8iZ li:nth-of-type(10) {
  left: 1125px;
  top: 0;
}
._2E6jtCgT ._1ihMz9IT {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-color: #fff;
  z-index: 1000;
  -webkit-transition: all 0.6s ease-in-out;
  transition: all 0.6s ease-in-out;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC {
  width: 1200px;
  height: 132px;
  margin: 0 auto;
  position: relative;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC ._2rSHHo9U {
  position: absolute;
  left: 35px;
  top: 41.6px;
  width: 1130px;
  height: 2px;
  background-color: #e7e3dc;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC ._2rSHHo9U i {
  display: block;
  height: 2px;
  -webkit-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li {
  position: absolute;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  z-index: 100;
  cursor: pointer;
  width: 56px;
  height: 56px;
  top: 41.6px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li p {
  text-align: center;
  color: #98a3b1;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li._2JnL_gCG p {
  color: #d7967f;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li._2WVkXTz5 {
  font-weight: 700;
  font-family: PingFangSC-Semibold -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li._2WVkXTz5 p {
  position: relative;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li._2WVkXTz5 p:before {
  content: ' ';
  position: absolute;
  left: 50%;
  bottom: -12px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 14px;
  height: 14px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADSUExURUxpcf/a2v/czPnTw//b0v/r4fbUx//////////h1PfVxP/ax/fUxfjVxf/WyffZx/nWw//awtORdPbTw/XTwvbUw/XTwvXTw//Wx/bTwvjTw/bVxOm6pfXTw/jWxfbSwuOul/XUw/bTw/jTw/fTxPXTxPHJte3DsOKul/XSwvXSw/XSwvbSxPbSw/XTw9yji/bTwu3CsNicgv////XNvP/9/em5pPbTw////+e2oe/Gs+u/qt+oj9aYfOOvmNughuKvmM+Ka82GZuq+qu7Fs9qghdKNWMAAAAA4dFJOUwAHDy8LBR0BAghCDSEyEhoqFf5yn1mHbBZcRTzVjSWv4FN7SWNPjajWpbe5OZWB8Je/94pnor93mDQ29AAAAV9JREFUeNqlzdlygjAUgOEgBBKQxbKqbIoC7rvTYovW5f1fqQlScFqv2n8yQ5hvTg74e4KANq9P2iBBAAhBuPttOwgRAgjiOMuu2ZWc7KEYQwQglpTkcrgcqsjP5ZIoEoaA4RRe27/9aK/xCscA3FB9uZPmeX7KT+QU37Qj+2oDAzrYHW7D94fC7bBLRymyomnHi9vxdiy6LWLbFFmKuEDdStYfZevE0gvEdKfW7dmWsXopWxmW3etqdCfkWk05GvRngftZ5Aaz/iCSmy0OAliNjt0zyR1XgxAgyN23eqNJeD6Hk5F338hBBAREH2Y7bd0zgjQNDE9vd1j6KBJAqTJRa2kYS4uY/G1UmUJNuz+f922zMIZaqZLTlMVhezBoD0W56Uil1cpOxSgSp2xpNUIstXhfY1nN51sSLhfWyimOyvOqo3CV1Uq4QSJUWa2EGRKhymoViNPIBTxLKOH/fQHMpD2nuvk3bwAAAABJRU5ErkJggg==)
    no-repeat 50%;
  background-size: cover;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li ._3PpgCJLA {
  display: block;
  border: none;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li ._3PpgCJLA._3W1_25Yq {
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li ._3a-pKTMT {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  pointer-events: none;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li ._3a-pKTMT ._3B6YH0ov {
  opacity: 0.5;
  z-index: -1;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li ._3a-pKTMT ._3B6YH0ov,
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li ._3a-pKTMT ._3LMLDUFo {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  display: block;
  border: none;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li ._3a-pKTMT ._3LMLDUFo {
  z-index: -2;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li img {
  width: 56px;
  height: 56px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li ._3W1_25Yq {
  margin-bottom: 5px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:first-of-type {
  left: 35px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(2) {
  left: 160px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(3) {
  left: 285px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(4) {
  left: 410px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(5) {
  left: 535px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(6) {
  left: 660px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(7) {
  left: 785px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(8) {
  left: 910px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(9) {
  left: 1035px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC li:nth-of-type(10) {
  left: 1160px;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC ._3a-pKTMT {
  width: 70px;
  height: 70px;
  position: relative;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC ._3a-pKTMT ._3B6YH0ov {
  width: 70px;
  height: 70px;
  -webkit-animation: _36nf9iJu 2s linear infinite;
  animation: _36nf9iJu 2s linear infinite;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC ._3a-pKTMT ._3LMLDUFo {
  width: 70px;
  height: 70px;
  -webkit-animation: _36nf9iJu 2s linear 0.3s infinite;
  animation: _36nf9iJu 2s linear 0.3s infinite;
}
._2E6jtCgT ._1ihMz9IT .EH7HrmCC p {
  font-size: 14px;
  line-height: 18px;
}
@-webkit-keyframes x2P9kU6U {
  0% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
    transform: translate3d(-50%, -50%, 0) scale(1);
    opacity: 1;
  }
  15% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1.25);
    transform: translate3d(-50%, -50%, 0) scale(1.25);
    opacity: 0.5;
  }
  30% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1.5);
    transform: translate3d(-50%, -50%, 0) scale(1.5);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
    transform: translate3d(-50%, -50%, 0) scale(1);
    opacity: 0;
  }
}
@keyframes x2P9kU6U {
  0% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
    transform: translate3d(-50%, -50%, 0) scale(1);
    opacity: 1;
  }
  15% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1.25);
    transform: translate3d(-50%, -50%, 0) scale(1.25);
    opacity: 0.5;
  }
  30% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1.5);
    transform: translate3d(-50%, -50%, 0) scale(1.5);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
    transform: translate3d(-50%, -50%, 0) scale(1);
    opacity: 0;
  }
}
@-webkit-keyframes _36nf9iJu {
  0% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
    transform: translate3d(-50%, -50%, 0) scale(1);
    opacity: 1;
  }
  15% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1.2);
    transform: translate3d(-50%, -50%, 0) scale(1.2);
    opacity: 0.5;
  }
  30% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1.3);
    transform: translate3d(-50%, -50%, 0) scale(1.3);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
    transform: translate3d(-50%, -50%, 0) scale(1);
    opacity: 0;
  }
}
@keyframes _36nf9iJu {
  0% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
    transform: translate3d(-50%, -50%, 0) scale(1);
    opacity: 1;
  }
  15% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1.2);
    transform: translate3d(-50%, -50%, 0) scale(1.2);
    opacity: 0.5;
  }
  30% {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1.3);
    transform: translate3d(-50%, -50%, 0) scale(1.3);
    opacity: 0;
  }
  to {
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
    transform: translate3d(-50%, -50%, 0) scale(1);
    opacity: 0;
  }
}
._29gnuiyG {
  width: 1200px;
  margin: 0 auto;
  height: 64px;
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-size: contain;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
._29gnuiyG ._35_vygsc {
  padding-left: 68px;
  width: 358px;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
}
._29gnuiyG ._35_vygsc h1 {
  font-size: 46px;
  color: #fff;
  line-height: 46px;
  margin-bottom: 7px;
}
._29gnuiyG ._35_vygsc h2 {
  font-size: 24px;
  color: #fff;
  font-family: serif !important;
}
._29gnuiyG ._2zJiZW9W {
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  padding-bottom: 2px;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
._29gnuiyG ._2zJiZW9W ._3gi7jqcw {
  margin-right: 15px;
  padding: 0 18px;
}
._3ca_2Jyu {
  width: 1400px;
  margin-left: -100px;
  position: relative;
  padding-bottom: 38px;
}
._3ca_2Jyu .swiper-container {
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
._3ca_2Jyu .swiper-container-no-flexbox .swiper-slide {
  float: left;
}
._3ca_2Jyu .swiper-container-vertical > .swiper-wrapper {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
}
._3ca_2Jyu .swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  box-sizing: initial;
}
._3ca_2Jyu .swiper-container-android .swiper-slide,
._3ca_2Jyu .swiper-wrapper {
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
._3ca_2Jyu .swiper-container-multirow > .swiper-wrapper {
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
._3ca_2Jyu .swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  margin: 0 auto;
}
._3ca_2Jyu .swiper-slide {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
}
._3ca_2Jyu .swiper-slide-invisible-blank {
  visibility: hidden;
}
._3ca_2Jyu .swiper-container-autoheight,
._3ca_2Jyu .swiper-container-autoheight .swiper-slide {
  height: auto;
}
._3ca_2Jyu .swiper-container-autoheight .swiper-wrapper {
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-transition-property: height, -webkit-transform;
  transition-property: height, -webkit-transform;
  transition-property: transform, height;
  transition-property: transform, height, -webkit-transform;
}
._3ca_2Jyu .swiper-container-3d {
  -webkit-perspective: 1200px;
  perspective: 1200px;
}
._3ca_2Jyu .swiper-container-3d .swiper-cube-shadow,
._3ca_2Jyu .swiper-container-3d .swiper-slide,
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-bottom,
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-left,
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-right,
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-top,
._3ca_2Jyu .swiper-container-3d .swiper-wrapper {
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-bottom,
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-left,
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-right,
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-left {
  background-image: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.5)), to(transparent));
  background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0.5), transparent);
  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.5), transparent);
}
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.5)), to(transparent));
  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5), transparent);
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.5), transparent);
}
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-top {
  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(transparent));
  background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.5), transparent);
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.5), transparent);
}
._3ca_2Jyu .swiper-container-3d .swiper-slide-shadow-bottom {
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(transparent));
  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5), transparent);
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.5), transparent);
}
._3ca_2Jyu .swiper-container-wp8-horizontal,
._3ca_2Jyu .swiper-container-wp8-horizontal > .swiper-wrapper {
  touch-action: pan-y;
}
._3ca_2Jyu .swiper-container-wp8-vertical,
._3ca_2Jyu .swiper-container-wp8-vertical > .swiper-wrapper {
  touch-action: pan-x;
}
._3ca_2Jyu .swiper-button-next,
._3ca_2Jyu .swiper-button-prev {
  position: absolute;
  top: 50%;
  width: 27px;
  height: 44px;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
  background-size: 27px 44px;
  background-position: 50%;
  background-repeat: no-repeat;
}
._3ca_2Jyu .swiper-button-next.swiper-button-disabled,
._3ca_2Jyu .swiper-button-prev.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}
._3ca_2Jyu .swiper-button-prev,
._3ca_2Jyu .swiper-container-rtl .swiper-button-next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
  left: 10px;
  right: auto;
}
._3ca_2Jyu .swiper-button-next,
._3ca_2Jyu .swiper-container-rtl .swiper-button-prev {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
  right: 10px;
  left: auto;
}
._3ca_2Jyu .swiper-button-prev.swiper-button-white,
._3ca_2Jyu .swiper-container-rtl .swiper-button-next.swiper-button-white {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E");
}
._3ca_2Jyu .swiper-button-next.swiper-button-white,
._3ca_2Jyu .swiper-container-rtl .swiper-button-prev.swiper-button-white {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E");
}
._3ca_2Jyu .swiper-button-prev.swiper-button-black,
._3ca_2Jyu .swiper-container-rtl .swiper-button-next.swiper-button-black {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E");
}
._3ca_2Jyu .swiper-button-next.swiper-button-black,
._3ca_2Jyu .swiper-container-rtl .swiper-button-prev.swiper-button-black {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E");
}
._3ca_2Jyu .swiper-button-lock {
  display: none;
}
._3ca_2Jyu .swiper-pagination {
  position: absolute;
  text-align: center;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  z-index: 10;
}
._3ca_2Jyu .swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}
._3ca_2Jyu .swiper-container-horizontal > .swiper-pagination-bullets,
._3ca_2Jyu .swiper-pagination-custom,
._3ca_2Jyu .swiper-pagination-fraction {
  bottom: 10px;
  left: 0;
  width: 100%;
}
._3ca_2Jyu .swiper-pagination-bullets-dynamic {
  overflow: hidden;
  font-size: 0;
}
._3ca_2Jyu .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  -webkit-transform: scale(0.33);
  transform: scale(0.33);
  position: relative;
}
._3ca_2Jyu .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,
._3ca_2Jyu .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  -webkit-transform: scale(1);
  transform: scale(1);
}
._3ca_2Jyu .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  -webkit-transform: scale(0.66);
  transform: scale(0.66);
}
._3ca_2Jyu .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  -webkit-transform: scale(0.33);
  transform: scale(0.33);
}
._3ca_2Jyu .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  -webkit-transform: scale(0.66);
  transform: scale(0.66);
}
._3ca_2Jyu .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  -webkit-transform: scale(0.33);
  transform: scale(0.33);
}
._3ca_2Jyu .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
}
._3ca_2Jyu button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  -webkit-appearance: none;
  appearance: none;
}
._3ca_2Jyu .swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}
._3ca_2Jyu .swiper-pagination-bullet-active {
  opacity: 1;
  background: #007aff;
}
._3ca_2Jyu .swiper-container-vertical > .swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  -webkit-transform: translate3d(0, -50%, 0);
  transform: translate3d(0, -50%, 0);
}
._3ca_2Jyu .swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 6px 0;
  display: block;
}
._3ca_2Jyu .swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 8px;
}
._3ca_2Jyu .swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  -webkit-transition: top 0.2s, -webkit-transform 0.2s;
  transition: top 0.2s, -webkit-transform 0.2s;
  transition: transform 0.2s, top 0.2s;
  transition: transform 0.2s, top 0.2s, -webkit-transform 0.2s;
}
._3ca_2Jyu .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
}
._3ca_2Jyu .swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  white-space: nowrap;
}
._3ca_2Jyu .swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  -webkit-transition: left 0.2s, -webkit-transform 0.2s;
  transition: left 0.2s, -webkit-transform 0.2s;
  transition: transform 0.2s, left 0.2s;
  transition: transform 0.2s, left 0.2s, -webkit-transform 0.2s;
}
._3ca_2Jyu .swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  -webkit-transition: right 0.2s, -webkit-transform 0.2s;
  transition: right 0.2s, -webkit-transform 0.2s;
  transition: transform 0.2s, right 0.2s;
  transition: transform 0.2s, right 0.2s, -webkit-transform 0.2s;
}
._3ca_2Jyu .swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}
._3ca_2Jyu .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: #007aff;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: left top;
  transform-origin: left top;
}
._3ca_2Jyu .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  -webkit-transform-origin: right top;
  transform-origin: right top;
}
._3ca_2Jyu .swiper-container-horizontal > .swiper-pagination-progressbar {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}
._3ca_2Jyu .swiper-container-vertical > .swiper-pagination-progressbar {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}
._3ca_2Jyu .swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}
._3ca_2Jyu .swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}
._3ca_2Jyu .swiper-pagination-white .swiper-pagination-bullet-active {
  background: #fff;
}
._3ca_2Jyu .swiper-pagination-progressbar.swiper-pagination-white {
  background: hsla(0, 0%, 100%, 0.25);
}
._3ca_2Jyu .swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {
  background: #fff;
}
._3ca_2Jyu .swiper-pagination-black .swiper-pagination-bullet-active {
  background: #000;
}
._3ca_2Jyu .swiper-pagination-progressbar.swiper-pagination-black {
  background: rgba(0, 0, 0, 0.25);
}
._3ca_2Jyu .swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {
  background: #000;
}
._3ca_2Jyu .swiper-pagination-lock {
  display: none;
}
._3ca_2Jyu .swiper-scrollbar {
  border-radius: 10px;
  position: relative;
  -ms-touch-action: none;
  background: rgba(0, 0, 0, 0.1);
}
._3ca_2Jyu .swiper-container-horizontal > .swiper-scrollbar {
  position: absolute;
  left: 1%;
  bottom: 3px;
  z-index: 50;
  height: 5px;
  width: 98%;
}
._3ca_2Jyu .swiper-container-vertical > .swiper-scrollbar {
  position: absolute;
  right: 3px;
  top: 1%;
  z-index: 50;
  width: 5px;
  height: 98%;
}
._3ca_2Jyu .swiper-scrollbar-drag {
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  left: 0;
  top: 0;
}
._3ca_2Jyu .swiper-scrollbar-cursor-drag {
  cursor: move;
}
._3ca_2Jyu .swiper-scrollbar-lock {
  display: none;
}
._3ca_2Jyu .swiper-zoom-container {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  text-align: center;
}
._3ca_2Jyu .swiper-zoom-container > canvas,
._3ca_2Jyu .swiper-zoom-container > img,
._3ca_2Jyu .swiper-zoom-container > svg {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
._3ca_2Jyu .swiper-slide-zoomed {
  cursor: move;
}
._3ca_2Jyu .swiper-lazy-preloader {
  width: 42px;
  height: 42px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -21px;
  margin-top: -21px;
  z-index: 10;
  -webkit-transform-origin: 50%;
  transform-origin: 50%;
  -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
  animation: swiper-preloader-spin 1s steps(12) infinite;
}
._3ca_2Jyu .swiper-lazy-preloader:after {
  display: block;
  content: '';
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
  background-position: 50%;
  background-size: 100%;
  background-repeat: no-repeat;
}
._3ca_2Jyu .swiper-lazy-preloader-white:after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
}
@-webkit-keyframes _3DHqAPkV {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes _3DHqAPkV {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
._3ca_2Jyu .swiper-container .swiper-notification {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  opacity: 0;
  z-index: -1000;
}
._3ca_2Jyu .swiper-container-fade.swiper-container-free-mode .swiper-slide {
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
._3ca_2Jyu .swiper-container-fade .swiper-slide {
  pointer-events: none;
  -webkit-transition-property: opacity;
  transition-property: opacity;
}
._3ca_2Jyu .swiper-container-fade .swiper-slide .swiper-slide {
  pointer-events: none;
}
._3ca_2Jyu .swiper-container-fade .swiper-slide-active,
._3ca_2Jyu .swiper-container-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
._3ca_2Jyu .swiper-container-cube {
  overflow: visible;
}
._3ca_2Jyu .swiper-container-cube .swiper-slide {
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: 1;
  visibility: hidden;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
}
._3ca_2Jyu .swiper-container-cube .swiper-slide .swiper-slide {
  pointer-events: none;
}
._3ca_2Jyu .swiper-container-cube.swiper-container-rtl .swiper-slide {
  -webkit-transform-origin: 100% 0;
  transform-origin: 100% 0;
}
._3ca_2Jyu .swiper-container-cube .swiper-slide-active {
  pointer-events: auto;
  visibility: visible;
}
._3ca_2Jyu .swiper-container-cube .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
._3ca_2Jyu .swiper-container-cube .swiper-slide-next,
._3ca_2Jyu .swiper-container-cube .swiper-slide-next + .swiper-slide,
._3ca_2Jyu .swiper-container-cube .swiper-slide-prev {
  pointer-events: auto;
  visibility: visible;
}
._3ca_2Jyu .swiper-container-cube .swiper-slide-shadow-bottom,
._3ca_2Jyu .swiper-container-cube .swiper-slide-shadow-left,
._3ca_2Jyu .swiper-container-cube .swiper-slide-shadow-right,
._3ca_2Jyu .swiper-container-cube .swiper-slide-shadow-top {
  z-index: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
._3ca_2Jyu .swiper-container-cube .swiper-cube-shadow {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.6;
  -webkit-filter: blur(50px);
  filter: blur(50px);
  z-index: 0;
}
._3ca_2Jyu .swiper-container-flip {
  overflow: visible;
}
._3ca_2Jyu .swiper-container-flip .swiper-slide {
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: 1;
}
._3ca_2Jyu .swiper-container-flip .swiper-slide .swiper-slide {
  pointer-events: none;
}
._3ca_2Jyu .swiper-container-flip .swiper-slide-active,
._3ca_2Jyu .swiper-container-flip .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
._3ca_2Jyu .swiper-container-flip .swiper-slide-shadow-bottom,
._3ca_2Jyu .swiper-container-flip .swiper-slide-shadow-left,
._3ca_2Jyu .swiper-container-flip .swiper-slide-shadow-right,
._3ca_2Jyu .swiper-container-flip .swiper-slide-shadow-top {
  z-index: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
._3ca_2Jyu .swiper-container-coverflow .swiper-wrapper {
  -ms-perspective: 1200px;
}
._3ca_2Jyu .swiper-container-horizontal {
  margin: 0 100px;
  position: static;
}
._3ca_2Jyu .swiper-button-prev {
  border: none;
  width: 72px;
  height: 72px;
  background-color: initial;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
  position: absolute;
  top: 118px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  left: 0;
  background-image: url(data:image/png;base64,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);
}
._3ca_2Jyu .swiper-button-prev:hover {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
._3ca_2Jyu .swiper-button-next {
  border: none;
  width: 72px;
  height: 72px;
  background-color: initial;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
  position: absolute;
  top: 118px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  right: 0;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQCAMAAADQmBKKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAKgUExURUxpcf///9be68/a4eHh4f///87m5v///////9D//9Lc5dra/9Pc7dXd49HX4c/Y38/X4czW4M7a5tHd6M/a4czX4dLh4c3X4NHa48/X387Y48zW383V4czW38zY5c3W38zX383X38/f383X4M3Y483W4c3X4M3W4MzW383X4M3W4MzX38zW383Z38zW38zW383Y38zW3szW3szW38zW38zW3s/Z4szW38zY4cvW4c3W39Te68zW38rS3czW383X4czW38zV383W4Nbe5s7X4NTb5dTb5tfe5sXO2ufv+eTr9Nfe59Pb493l7+jw+d3m8N3k7uHo8dXd5dLa49vj6+jv+N3k7ePq8+Tr8+Hn8OXt9+Ps9t/m7tff59DZ4v///+zz+/v8/v39/+z0+/L3/Pf7/uvy+/T5/fL3/fb5/e72/Pn7/fr7/u70+/7//+rz++ry+ufw+ujx+vb5/PL4/PD2/O/1/Pf6/vv7/f7+//z9/vX5/fb6/P39/u3z++zz+v7+/vj5/e/2+/T4/Pn7/u71++ny+/n8/ujx++v0+/j6/fH3+/D1+/bVxtiXgOjy+7K9zPHf2uXt+uXIv/Tm4eLs+e3Dsvj6/OKtme7Z0e/Gtea0ofHb092jjem7qeu/revRyOCple3Uy/Pj3fv9/+i4pOfLwfTi2vr8/bbAz7nD0u7Wztufie70/OSxnePGvvjo4vLe1unOxeDp9tHb6dqbhd3m883X5cPN2+rSy/XSw+7c1trj8OvWz9+mkfbl3vLMvMnT4sDK2ejPyPDJufL1+Nbg7r7I1rzG1Pjp5ObMxPj6+/PPv/Pq6Orv9ebr8e31/O/z98bQ3u3g3vb29/by8uzn6PPu7fDw89nf6N3i6u70+ubt9uDl7ODn8PH1+qkfjWoAAACTdFJOUwAEDBkIAwoBAgUdBw4SJjAqMhUWIjYROhwgJGc9UBRXckAQYS1DTUl3U1xskCiGlkdefoOcpRuLPEVv/nv9qjOwn/7Ttf733f30neW/7+X4bovJ8mOzlsmmetr0vauR/////////////////////////////////////////////////////////////////////rGmyNQAABsrSURBVHja7ZyJW1Pnnsdnxpl7Z7SVqiCLoCBbgapArQqIWHHft1rb2z7AJBpjpCBJ6AVUGELMJbG30ip1qwXXgF2uSgE1WqGy3CrKoqK4/Svz/f3enHNy7hGoYm+feZ75Pu/DOQl53/PJ9/d7l+Sck3/5f/2/fk/90av/9Ep6/DuhgOA/oH+F/otFe/SMF+2fzsIcY8aM+Xcf4SGT/dOoBAyzEMkf/vCHf4Ne84r28RRxMZWA+m1p4AxgmIVApk58/fXXJ08ez5o8GQ8mTiUwogIUnGKm35gGMGCZ+Prk8RMmjBo1alZQ0GhWUNAsPJwwYfzk1yeCClC/HRPjKDSAAUrQ6OBgf/+QkLGyQkL8/YODRwcBC1AKEyP9FjiIFNGMBwxYQsZOeyMqys/Pb1wGaxx2o6LemDY2BFSAGk9MiN2rRWIcjtUYiWbW6GB/YvHLiFi7/P3Vy5Yt++KLgwe/+AI7q9/fvDYiw4+o/INHz5KYxlDkCOkVusM4FKnRwSFjCWbte6sPDqLV760lqLEhwaMpdoz0qlzywZkKc4LgzRt+GWESzM6thYZPKxynirKyik45Kj41FG7dKUHFZfi9AZ+CYNNUH6SR2qO4w+ZMixoXunz1xYMIUbYhJ+u5yjFkf0FMyzZHjIuaxjYpLqHJEdqDVJZwYE7ABx8Szd5tahgt1Lb8gwcvHlz9QQBskpCQ3mzSiO15beJ4L866P128eHGnHhEaXkX6nXjxsnVepPETX1NMGpk9UydPCGKcTcA5mOvI+tVy5B4E0nJGCpoweepITJLs4WgFh1CwlgFnH8x5ERUVAoldCgnmuEkmvRwP2zNqtP+0qIy4D4Hj+iTrhfWJC0ir4zKipvmPHsUmCaKX40H2kD3jAt9DOuQyzksgPULl9wLHwSTKpJcg4nSmbEa4gmBPwEYkz86crJeWA+n9p40BMCkIYaPc5tR+UR4OF7IncPnFxoO2rBHJBpOWByKTOGwvRMTdC+mM9EG4xkZlRHzY2LgTuTwyFe1sbPwwOiNqLMKGREJq/+rOJvFMHD8reKwfwtV48VnWK9Czi43LNgb4jQ2eNX6iRPQrDRI8E2b5T/MLXHux8aIz65XIebGx8YNAv2n+syYIIlj06/oX8yCd0bvWNTY+RrhejYoeNzauQ29DaoNI5NEL8WTMWQ4edPZXpU9AtHxOhorohXg2exoLsl6p8hsb39MQDTseenlCl3saS1/Wi6xPULK0Km30LA/1Eg0/Qgoe9PdZxLOu0ZNf9ElRUVZRFgpv+UBln5SVZZUpzykAWiht/XyPZx0RzULvF0RDGkTzhZfng0bPTrTJjbHQuvwY+3ywsqIyFH4MUPU+/jyv/k5P4wdeIppFYNFQAaP5a/Ko4Gnj5mxs9DymRqXGZQAWdlDk56HBoLT1H3saN84ZNy141GTMIpxGQwRsDOYvjM9+gbFrPBeLiyTJTmil/Z8CPchrLnr+FBvohzEb89qYwYMGg0RCjwZP9IeexlNyQ8p2d9FulKKi4qLi4rJi5SDKY95HkUG09f/c6PkwGkSjRWLDosEDhoQOCokKiN7s8diKIalh7LCwg6J6XvOc6vXa+oCyeTybowOiQoKQ2IMGjUcgSiAkdMRaj6f0VNEp0dCp4lMo8hYadB+Snxu0/u7dZbc9nrURSGykkRiNBg0YEmia35zENe13RMNamBcG09bf/d9FdzxrEuf4TUMaDRY00cOmThgd4heY8lG7x1RcnFOcg6I0nHNKeaz8T/V/FOl1Q9Yv+7On/f2UQL+Q0RPQ99kirUHcwxCwgIiNnvZHOep3hpZI2KgaRyEI1WtYp4apv/tZu2djRACCxj0NFmkN4h6GESg0dlX705xih0anHKdQxH6OIwfF4Sh2FKM4IGWft0PVB9fu4qftq2JDMRqhp0kWaQ2iHhaYsqm93Yxj/XbKobiZ29s3pQRST9NaxAaJjEYPi1nT/tiRU+FwVDgqUOQty+QwoTz/OSFtPe1rcwjpdvuaGPQ05LXGIhiEMRpzGGV04uZ2j8OxQ2kEGhpOSAM8ZH3qF572zYmU15jTMF6zRVqDAqLD1rTfLpYbMVWYUKSt3OgO0w4Tyg6oQpLqNcPVd+e4i2+nrQmLDtBaxEBkEM0ZobHL09or3CaIG9hSsQVFOeAW05aKHRU7wMJOwEneV70eLxqqPh4LoJz29uWxoTSDTOUs0hrkzwalPXY40IzcMDfi3OJEEc85Tap3rdIWSUPWdzorTI4cySJ/jUXeLsYGbUpLM+EgUgOQ3Ag/9r5Th9uB4nab3F43nBUoTki8Tltf/bjCDSB3Wtomtog7mi+QTwatSnuM9qVGNVtICgeKnNTiICYNlGYr6VNTBYgep63yyaI/qiL22uSgEL85sZFpaXpTBWoaUcn5KYrYGj81GvHc0W8+89VPJlbV4b/5qv9/nJC2vqpNwLtzbGlpkbFz/EKCJr/GMVOlNAbpgIiwjxo8bhhkhNAGNyQLD+7VHvfhuXz5LDv11dVzPjwHDnTdFG9IW195DKfdjmJP2kdhEQEYrkVaqyPmHxWYOGVVw22HaQsBqRsq+bSkhFq5e+i0gnP51q1jN00UuSsnFJ6//fTT380g0tYv8YWCs+6c2w2rpiQGRvmrYkYR45QeFxGztqHBbEJjqKxqCAVbkvn77xkGNND165+BCLpSwzSAYR24a5RCJdWXtxC/OQA5nA0Na2MixnFaU8yUiE3klI57v8FjYqDniq3edfwQ8TDN9Rs3bly+y0Qna37y0pw8efbs2ZN3jULaphiMidD1nza8H8dpPRExk4EoYrMwa8RSxEwms9FmK7GVlBhKDCzssGxGm9mIYFTXyjRHoOv3mOjABYFzllR1tuquU4KR6qNRFGnfjJZMDopZLOaPWRQzCcgbMUyr8Q0NLmQ0swggaWsz2FBEHjnPXLsh4VRXV39zQxB1XTgLHNZ5qOqeUQqTXJ/akxmNBGRrSIvHFOuNmQDyidi6hjQHB4wbsNgsFoPFgCK2BhE2mFTz9RHQCByoup+J+i8InCrgHDt/7Fi/2WyGFShcX5ZorwTtmEw5DQ3rfGLmTSG5j73f8LTCucsMFmpgm2Ebik9DZLmZ8sh4+Otq0Aic48ePf9PlJTrP7hAQqV8OlwyitItnMYM4kERyP0MSMRCPipg2YuJXNd1GxOCOfpt+G4peb9FbUMR2GyynPDCajc6+a8erCYZ1+vTpA0x0r+YYwbAOQ102s02I61u4TWobu3hzuzAW3W5aFR+D6YPHRgbiFMKomBEdFpnW9MzkNJdYDFJFWWgNhd6lcMl5oPY485wmHT16tKqiAkR3Txw+L+OcO3euS3LHtk0FBOE5NOPQN6VFhkVnYGzkJGIgbwqlxKU2NcEgBoKoskaIWwksAlJX7WnGOQp9Dx3DfIaB89xhxhE8J070sT2wWEh2HrIYzMYtJkdTU2pcijeJAMQ5zSmETr+pKY2AqL5SmbcKoEX0NhD1Hz0q4xyCTjCR+fA5AcM8TAR7pPqqdgmowpHWtAkdn5NIZDXlNCZWSqGPmjwV6GOW5zhj1VtRaA+4eNNm9Np7x78XNKTa2tozJhpUb1ZJNNClmporeuquohF1WxYMaya3p+kjJBFNsJTVIqfFKBSWtKLpKeW0Ra6kvBvxWElIM4iMd6slGujatWvVN52Q+aRCA/18uA35I0hUIWMgp+lp04qkMB6JOKsBJHIao1Akd7ISm+CRIFRbSLQFJIx5d28QkKD5Gjp+k9c8BwhI0FyALrWhgmhUErcHpzHFoptFYiTirAYQdTIsPTinJ6U19Qgg61BiIgoaPLpZc1TB+fbbb4/eBQ8S/rCEA/3yy6Ue9gdSA1lsJU5TT1PaJM5qLEHQzRhoohgWJSCXfp/dan8+zXYvkQuZVALHnedOMw3j/Pjjj4fuIWZGc9cxpmGcM2fOXHjARFx/O4oVzdv36V0SkBgaJ3qB5E6WsKjpmeRQobWw0F5ot2+3Sw0o+97ctvE84jx/nGkY569//eu1fl4K9Z+vETTQl19+eaZf7yq37iMehiJZ4XOJ0fSspSFB7mYExL2eVq/xCU0teuS03uXaRwdnYQdcMhzKvn3l5S4XLAKRmTz66RuGAQ7r6y4zVHKv6gJoGId13+UCkBWNQNyW1QUio1Pfsighntax3O8JiNce6PUEZHYaDTCIABiE1V3YjcK7/Ly1nBxCMSCzQfT3anZH0rcHMMczkYzzww8/fHkftitvrHB7YWE5A5lbmhLQ78UKxAtEM1lETFJqSwsSwKB3WXNzu3O7UXJz7bl2e7ddAOUW8vOF9u3sEXLSwGnk7Kr+FiCyfuyjdY+hreoC0zAQyn27qI/m7HY0nAuLDFgUtbSkJsVE0GxGQBgXeWodJwFRyOwMoZKuW0fCBmTbrTDJijQiIBD1H6WliKwbZ81mAD07fKUKOn9FqOq+HRCoL7WXi0YUoHE8vWJkZCAeFyPDOWTIafv2QgJQi2FQcmEbwuZCTmKAJJ6ua0cuX/5M0d/NJWTQpSsHfNWPUBXK7X6n++47O95TidPW0hQeySOjAOKBWgbSex3KlSBQkYSN8hh5sA92MxAcOnDtyK3LkMTTxUuOBzVXTp5U8ZBBuaiPIt4cAZmdzwhIHqr/EajNBCDrPjvqKBDZumwUAZP93R4d5VV5OXg4ZCdrj1y/fuuWzIR1IojugYcl8VAucn1ui4Ws3mZ2trUsHhRoUUsPOYQhRzeY9ugICDxW7wRSVVt948Z1yIt0r8RmZn+qzgJHYnpAiWxX3hwrF42YnT1DAC3uvW3iHOpmb/J0eazsvGwU3oLHTgZhKIffepv5yqFqJPQNMLFN4EH62PovIZ+FGOkBokU0e/YAhqHywGW34y05b6uA1Em9uOWOyUkO6XSleaUoChAkNmiXgKwEZLEd/v4bdKsjEtMt8CB/+k9cgSSiKvBQ+sBetMHtyUBI6jsEpCS1qtuv6H2CqcNiRU6jpkp78/aioBXoETwSg+O5o1jHEpKwycvTde4YeBQk4tmjA8NW0Wp+Xj5Ktg6t6EucT3pX+HZ71cCY2fsQQHp9oV0nKv0D0FbJIIz7lEM1WMSCCGKkW3d5vdqFFeOxw9Loc6UPPBwmBlKEpuxWhOxhb6bPwKieOj7uxZraTA5lV+6V3omyBVFeaXbpo0dAQrd31ZyGjkMC6dbdEgPzCF0RTH099kf20lJdaSVq792bvzcf4vZ0j7a74FBT78c+U4d6cp3e2+tAN3MV6kpLUQm1JXFDW/PzRBLZuwut1mcnaEGtMF2wGQTP1avnrp4TUMSD16NWaR7VV9rDu9PpMOEbnb29030mV/XyY25LLwYig96ai/oyCIoCVLqnFDEr3L6v7bPTWE4zEjPVIFrod12HL12VBKK+R7mPSkGTJ4CU9gr25qMhl8XY1tsy12f5oV6gvbm49w4lkRUWoYGC/IIC1GRhpyA/vxSNk0H28p7PTh+CZKYTBsJxgQeSkfoQKhhEiUz1CwAjQyGJCjFu3Old/KbPAk29hH1zCWW1GXOHLjtfBpGFRvLoCLDowWe0dGUkZjrHy3jw/PxzTc0llsSD4JOofoHcHjYImdVqMz5sXvKmzxJWvcgP/7i5hZLIaqdmuOJfCv6CIrZ4W+SRrtv+4PohrKMZiZkO60ltB67+LCSQ+rJpLNvKjkjtkD4v+PxzDpldb3OmN38c7rvIV30MSn27t/kZDY1wCEA7C3aiFMhgeFv5pfnI6v4jtVi2EhIEoCu8Yu7pu/QLJJBqfr7Ul0fmsET9nX9R2tuJjpZr15t7mnvfTvX9GKT6oJiQvLhZJBEGor2SM7z1toTGdbr71bSG/hoSLvVZgWPtqfr5DHhkpvvZpdnenPmc60MMJOD25mdjmW9+2rw4OcHng6L6o/SkuUuaFyFmFj1iBofUohzIQy72HacV67eQQOqzQvYHV37B0pCRmOl+nvAGkhqCRSi8CyxEDCm0qHnJ3Enqj9LKlw3I6pnNzTbMrwDKQ1sqHsmhvqM/YpVKSMxUex80dvuDq1/+ACAgfclA9yUc5tGqQKSQq7l5JuW08mWD+uuY8LcXNz8V05mOkkgLVHD1e+/CWTDV3reT+q/+IImohuUBUJ4OEXvSvPjtcPXXMcoXVpxEmc0LHCqLOO5KDl2qJRqZSfDk3r8EEkW/3PHhkev7Ci3tQcScC5ozkUKqL6yUr/R4aHyrubWtwlmyTV9IPV/j0FXiUVTLCwudhocGQjGwqjkkODbIbjH3tDa/xcOi8pWe+ktPxGxD64CDev6+3OxSQlDGIh5qMRLl6UgAweeiQozaOl7oQBg2WZI9+er6vsMIOmuu1WAcaKWIqb/0VH8tnJq8srX5qx20kC3PzUNP8xUfCAfMo2XoHjiTq5OFWQ4SizpMWoJpEFHASimDbM2tK5NT1V8Lq784R8xmL2h94qhwmreJ4XovjaqfK0To95WlvChWlC05w95I85UyKov62lF610DrgtmImOaLc3XM1rc2O90ImoWJBBA3hGFIeAQJJmnBXllZWQo7s8XaiZXHM7oMpAZDG93llhJzc+t6dcQApD75gn42lyzKoa6PVQjNsfKkyAMjqTS7shKzJgrAKrHNVq0uGapAnkxVWxZM1hW6bM4nMGhuQrzm5AslkU8/m57Z0ex2CKJuLEOkEPCWDwaibMCwMD/IEBwxlnJwUU/aMhjqg8diNjd3ZE736WNIIe0JPEywyW+ldwzkuE34NtZlR9RoOY0DCjDsVdLHI1kIFUOJZS6vBFEIQM4ndX0y2W6nD2QDHelvJacmqU7gaU9xkkXrOzrackwmI3mEgMjvUKyvRRaJkBGMHCZ0rq0oUg4pz6vro3Zuuctm7OnoWE8GqU9xak8CR8KiDR0LihE0o8Gi345hZmsevzPW1rytW7GpJJVWliKiMgz+9Y8fm7T72GTbsVI0mhZ0bIBBkeqTwNrT5GzRvNaOOyCSP1YryYqi2Wcpz2m36v9jTKXvGO50tM5jg9SnybUXErBFSzqav5KIrHYaaVTKlj9a88NKGIY/irTPqT+NIYFszR0ryCDNhQSqtJYtmpHeuaAYie0021zsUfYwB+Z3X5lP+6rnUFSvBQ54bGbTgs70GbJBqpTWXoyShLFoYWvnk+Ic9siiLy8nJnEQdDEUsa3Ec5KU/ymgJLyIVcn1s7PtdpfFtss50Nm6EGNQkupilMEu15mC4fqtzM7OB+xRCYbscrvOnk1tqmBQaKvACGleg10C5H17rgv+OB90di55C4P0FO3lOtoLmni4nj5jQ2frTRCRR9v0VnxxqtNI+3XfcP+DP9TBzK2dG2ZM50E6Q2uQ9pKvOOT17JnpneluLxHGI0RNc2D4hvJ8AEgLSPECzy40PXM2MjpOdcnX4BfFIa8RtIWtSGzKoy1GswEmwaVuAdFtp4NpDyxgVWB4Kb+eZbeyP6YF9a0LETBktOqiuMEvG0TQqKet7KhfBCI3jdkGPU4NgIgOACblYBA2qgPL+8r/CRSfwjCB4SzrovqOldTDEDDVZYNDXVgZRz1txvrO+oe7izEeofvzacpya+H2bjq9oBxQK/X/xOkI2it36YnH8bC+M3MG9bA41YWVw1x6KtIos14QcffHPGJxlZerD+p7TgRFgQW46jlruQXdHf48rK9fIhJIfenpMBfnijSauaS+fhGIaECCSQa9BakkHwjHVB9YSHLE5zX46h/naszgcSyqr18xUySQ6uLcYS9fpjQCETxa4CYi9LZd+P7Q4sIwiXNVfNByfDu8vVxAKI9VgHiI15fz6cxdJuQz/AEPJZD68uXhL/AOE0TIo/SbuOjQjd4GJIM45W2FUdIBGUIj5X9Wq/hCe4vJbUtH/gieMM0F3sNdAp+CKYSIVnbUdTzYzb0NSOhvFiC5YBTlOMNowIQr4mwoCnjMsMftvt1R37GeeDBlpGgugR/uJgEktpdoaV39QFmxiJvJaCSXWDiYOOcpgWFfEu/yCSOYY9tldIJnoL5u6UrBg4TW3CQw/G0UEtG8DXV16TfLBJG42skGJpcLCcWyqsWAeu9JPpsNuYwr+NzmBXV1G+ZJPNrbKIa/0UQhemdJfV3nHRDxCEBM8Akjk+SUfC5ekYUFGjPMAY77aWdd/ZJ3FB7tjSbD34rDRMjs2TPeQdjq0ts4bkASyWRkn1CeL/yDT4ASjbsnvQ7hemfGbOQz8ahvxXmBm5US0dfCk2fPeHfeivq6uodur0uc31uM5BMuNoIIS774iZ/YZd4lLg2ETA/r6upXzHt3xuzkcPSvxJHcPpUCotS50xG2hXiTnQPu3bu96e0W14MCClToRYxBGbMLLOJ6LoFzc6AT9i5EuKbPTQVPiobnhW54i46ZEolEIpMyEbf6hya4xEwwqoKih0tKIaOPnLgKh+TAkPrVw3pEK5PsQfpETomJ1tzw9oK3BEbHxiUhbGTSvCVAqlvUUyYx8QW6Jo0cJr7MHRco9yyq279/6ZJ5ZA/ClRQXG625JfCFb5qMSIyjsJFJ78zPXLp///7WgZtluwElRFBuEkB4n4VL3M0DrfsJZ/47ZA+FKy4xQnPT5IvfVopEorCFI5MYKb0Oh0kfkHxir6S7FeSHxT0D6XhZXXom4SB7wilcSB/NbaUvdeNtRGxcPDIpmZHmLVxBNu2vX/Ckrbhsd7FGOW1PFtTvJ3NWLJzHOMnInvi42AjNjbcvfWtyKExKmpTKSMil+StXpOOQUGf6oid3bve03XQX32zruX3nyaL0zv2Mm75h5XzkDuOkTkqCPaGaW5NHcvN2RGLYlEhGms02zZ+/fsNSQGnFMJnz57M5sxknckpYYoTm5u0R3t6O7iaQkN6wCUyAWpi5YkP60o7O+jrkS31nx9L0DSsyFwIGNDAHqSxw0Lk0t7eP/AcAQoGEwCWEv5kMJoZiKnAJgYRZGAY0yW+GJyBYwAnV/gDAyH8iQUKKh03ENJ2gZsyc+S64hEDy7syZMwhmOtHAnHiBo/2JhFf1IxJzIhJj4sBEPs1NfhtUwAIYi/Zmg+Xt5LnwhmjiYhIj5gz5IxIj/5mNwIjoWME0KQFOASsZYELJyUCBMwmTBE1sdETgsD+zMfIfIiGmxJgwQCURVUJCamo4KzUVD8CSBJiwmESiGeSHSF75T7UEBIZGp8QCKm7KlPj4pKRIVlJSfPyUKXGAiU2JDg0MGOqnWl79j9kEACoiOiUxNjYmJsyrmJjY2MSU6AjABIzgx2xG8HM/oAqcExohK3ROIFhG/nM/v/8PIv3+Pxn1+/+o1v/Znx37XxrR4Bh81p1iAAAAAElFTkSuQmCC);
}
._3ca_2Jyu .swiper-button-next:hover {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
._3ca_2Jyu .swiper-button-disabled {
  opacity: 0.5 !important;
}
._3ca_2Jyu .swiper-button-disabled:hover {
  -webkit-transform: scale(1);
  transform: scale(1);
}
._3ca_2Jyu ._1SRSvRL2 {
  position: absolute;
  bottom: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 10;
  height: 32px;
  padding: 2px 4px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  border-radius: 26px;
  cursor: pointer;
  background-image: -webkit-linear-gradient(top, #fff 15%, #d5e0eb 67%, #f2f8fc 95%);
  background-image: linear-gradient(180deg, #fff 15%, #d5e0eb 67%, #f2f8fc 95%);
  border: 1px solid #ccd7e6;
  box-shadow: 0 2px 6px -1px #d5e5f4, inset -2px 0 4px 0 #fff, inset 2px -3px 4px 0 #fff;
}
._3ca_2Jyu ._1SRSvRL2 ._138NHyh1 {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #98a3b1;
  cursor: pointer;
  position: relative;
  z-index: 2;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
._3ca_2Jyu ._1SRSvRL2 ._138NHyh1._2R8-V5Av {
  color: #fff;
}
._3ca_2Jyu ._1SRSvRL2 ._2WkFDe2d {
  pointer-events: none;
  position: absolute;
  z-index: 1;
  height: 32px;
  -webkit-transition: left 0.3s ease;
  transition: left 0.3s ease;
  border-radius: 26px;
  cursor: pointer;
  background-image: -webkit-linear-gradient(top, #fff6f3 8%, #cf866b 64%, #e3aa96 95%);
  background-image: linear-gradient(180deg, #fff6f3 8%, #cf866b 64%, #e3aa96 95%);
  border: 1px solid #eec6b9;
  box-shadow: 0 2px 6px -1px #e4c3b8, inset 0 -2px 5px 0 hsla(0, 0%, 100%, 0.58), inset -2px 0 5px 0 hsla(0, 0%, 100%, 0.88), inset 2px 0 5px 0 hsla(0, 0%, 100%, 0.88);
}
._3ca_2Jyu ._1SRSvRL2._2qevlAbJ ._2WkFDe2d {
  width: 40px !important;
}
._3bMENp8D {
  position: relative;
  margin: 60px 0 25px;
  overflow: visible !important;
  cursor: pointer;
}
._3bMENp8D ._2LadCtQS {
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-transition: -webkit-transform 0.3s ease-in-out;
  transition: -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
  width: 383px;
  background-color: #fff;
  box-shadow: 0 2px 6px 0 #cbd5de;
  border-radius: 4px;
  overflow: hidden;
}
._3bMENp8D:hover ._2LadCtQS {
  -webkit-transform: translate3d(0, -6px, 0);
  transform: translate3d(0, -6px, 0);
}
._3bMENp8D ._3GsRvA8a {
  width: 100%;
  height: 108px;
  object-fit: cover;
}
._3bMENp8D ._30ojahN- {
  width: 100%;
  padding: 12px;
  font-family: PingFangSC-Regular, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
}
._3bMENp8D ._30ojahN- ._2B7N7wvD {
  font-size: 18px;
  color: #3f5075;
}
._3bMENp8D ._30ojahN- .oWM839X1 {
  margin-top: 4px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._3bMENp8D ._30ojahN- .oWM839X1 ._2_rjAgsL {
  font-size: 12px;
  color: #98a3b1;
}
._3bMENp8D ._30ojahN- .oWM839X1 ._3EJ-Wmj9 {
  font-size: 14px;
  color: #d7967f;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._3bMENp8D ._30ojahN- .oWM839X1 ._3EJ-Wmj9 img {
  width: 10px;
  height: auto;
}
._1qdtjegd {
  font-family: PingFangSC-Regular, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
  width: 100%;
  margin: 55px 0 30px;
  position: relative;
  font-size: 18px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background-color: #fff;
}
._1qdtjegd:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  pointer-events: none;
  width: 100%;
  height: 70px;
  background-image: -webkit-linear-gradient(315deg, #ffe9d6, #ffe4d6);
  background-image: linear-gradient(135deg, #ffe9d6, #ffe4d6);
}
._1qdtjegd li {
  height: auto;
  position: relative;
  color: #3f5075;
  z-index: 1;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}
._1qdtjegd li .-p-khenT,
._1qdtjegd li.sWAv_g1H {
  color: #d7967f;
  font-weight: bolder;
}
._1qdtjegd li img {
  width: 54px;
  height: 54px;
  visibility: hidden;
  position: absolute;
  top: -27px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
._1qdtjegd li div {
  width: 100px;
  height: 70px;
  border-right-color: #f0f0f0;
  border-top-color: #f0f0f0;
  border-left: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  border-right-style: solid;
  border-top-style: solid;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._1qdtjegd li._3EaYtsps {
  background-image: -webkit-linear-gradient(top, #edc1ae, #c37a5d);
  background-image: linear-gradient(180deg, #edc1ae 0, #c37a5d);
  z-index: 2;
  box-shadow: 0 2px 20px 0 rgba(173, 165, 188, 0.16);
  -webkit-transform: translateY(-21px);
  transform: translateY(-21px);
  margin-bottom: -21px;
}
._1qdtjegd li._3EaYtsps .-p-khenT {
  height: 91px;
}
._1qdtjegd li._3EaYtsps img {
  visibility: visible;
}
._1qdtjegd li._3EaYtsps div {
  color: #fff;
  font-size: 20px;
}
._36tYfDFP {
  font-size: 16px;
  color: #98a3b1;
}
._3EUFt5Wv,
._36tYfDFP {
  font-family: PingFangSC-Regular, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
}
._3EUFt5Wv ._3VD5zTpM {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin: 40px 0;
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 {
  width: 602px;
  height: 186px;
  background-image: url(/static/image/vip_promotion_1-f151.png);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9:nth-of-type(n + 2) {
  margin-left: 12px;
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._1nSvFFDr {
  width: 148px;
  height: auto;
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._3d_hDAu4 {
  margin-left: 20px;
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._3d_hDAu4 ._15yexfD5 {
  font-size: 20px;
  line-height: 28px;
  color: #98a3b1;
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._3d_hDAu4 ._3cIZGfn2 {
  color: #d7967f;
  font-size: 50px;
  line-height: 50px;
  font-weight: 700;
}
._3EUFt5Wv ._3VD5zTpM ._2szQExG9 ._3d_hDAu4 ._3cIZGfn2 span {
  font-weight: 700;
  font-size: 28px;
}
._3EUFt5Wv .r6FQ6TfK {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
._3EUFt5Wv .r6FQ6TfK,
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 {
  width: 224px;
  height: 396px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  padding: 118px 30px 0;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._15yexfD5 {
  font-size: 24px;
  font-family: PingFangSC-Semibold -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._3ZNmmsin {
  width: 100%;
  height: 90px;
  margin: 38px 0 29px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._3ZNmmsin ._2_3Gl8dL,
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._3ZNmmsin .ELKEJniT {
  font-size: 60px;
  font-family: PingFangSC-Medium, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._3ZNmmsin .ELKEJniT {
  position: relative;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._3ZNmmsin .ELKEJniT span {
  position: absolute;
  top: 10px;
  left: -19px;
  font-size: 24px;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._3ZNmmsin ._2W_CrD6j,
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._3ZNmmsin .ELKEJniT span {
  font-family: PingFangSC-Semibold -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._3ZNmmsin ._2W_CrD6j {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._2zB6FJsa {
  font-family: PingFangSC-Regular, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 16px;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._1l6jebz9 {
  line-height: 36px;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._1z15DlT9 {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._1HaNGelw,
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._1z15DlT9 {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._1HaNGelw {
  width: 110px;
  height: 36px;
  color: #fff;
  border: none;
  outline: none;
  background-color: initial;
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  text-align: center;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._1HaNGelw[disabled] {
  cursor: not-allowed;
}
._3EUFt5Wv .r6FQ6TfK ._1SqFQXQ3 ._162NZCRL {
  color: #624580;
  font-size: 12px;
  line-height: 17px;
  padding-top: 4px;
}
._6M6n3DaL {
  font-family: PingFangSC-Regular, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
  padding-left: 77px;
  margin-top: -20px;
}
._6M6n3DaL h1,
._6M6n3DaL h2 {
  counter-increment: my-awesome-counter;
  position: relative;
  text-align: justify;
  font-weight: 700;
  color: #d7967f;
  font-size: 20px;
  height: 64px;
  line-height: 64px;
}
._6M6n3DaL h1:before,
._6M6n3DaL h2:before {
  content: counter(my-awesome-counter) '.';
  width: 64px;
  height: 64px;
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: 100% 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  position: absolute;
  top: 0;
  color: #fff;
  left: -77px;
  font-weight: 400;
}
._6M6n3DaL h2:before {
  content: '\6CE8';
}
._6M6n3DaL p {
  font-size: 16px;
  color: #3f5075;
  line-height: 24px;
  display: inline-block;
  margin-bottom: 10px;
  text-align: justify;
  letter-spacing: 0;
}
._6M6n3DaL table,
._6M6n3DaL td,
._6M6n3DaL th {
  border: 1px solid #f0f0f0;
}
._6M6n3DaL table {
  border-collapse: collapse;
  margin-top: 20px;
  background: #fff;
  table-layout: fixed;
  margin-left: -77px;
  margin-bottom: 30px;
}
._6M6n3DaL table tr:first-of-type,
._6M6n3DaL table tr:nth-of-type(2) {
  background: -webkit-linear-gradient(315deg, #ffe9d6, #ffe4d6);
  background: linear-gradient(135deg, #ffe9d6, #ffe4d6);
  color: #d7967f;
}
._6M6n3DaL table tr:first-of-type td,
._6M6n3DaL table tr:nth-of-type(2) td {
  color: #d7967f;
  font-weight: 600;
}
._6M6n3DaL table td {
  height: 50px;
  width: 100px;
  line-height: 50px;
  vertical-align: middle;
  text-align: center;
}
._6M6n3DaL table td,
._6M6n3DaL table td span {
  color: #3d5077;
  font-size: 18px;
}
._6M6n3DaL table tbody {
  color: #3f5075;
}
._3YKldOVt {
  border: 1px solid #dbe3f1;
  box-sizing: border-box;
  border-radius: 8px;
  height: 38px;
  line-height: 38px;
  cursor: pointer;
  margin-bottom: 20px;
}
._3YKldOVt._2eknDuxP {
  border-color: #d7967f;
  color: #d7967f;
}
._3YKldOVt.mbVdyzxY {
  opacity: 0.5;
  cursor: not-allowed;
}
._3YKldOVt ._33TBok34 {
  margin-left: 20px;
}
.qLmI2B1j {
  line-height: 120px;
}
._2AO3XhOj span {
  color: #d7967f;
}
._2AO3XhOj ._3pCaO6su {
  margin: 20px auto 10px;
}
._2AO3XhOj ._3i_bnZ29 {
  color: #98a3b1;
}
._3LPqql-T {
  width: 100%;
  height: auto;
  background: url(/static/bg-eb3e.jpg) top;
  background-size: 100% auto;
  padding-bottom: 80px;
  font-family: PingFangSC-Regular, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}
._3LPqql-T section {
  width: 1200px;
  margin: 0 auto;
}

._1qdtjegd li div[data-v-0d776141] {
  width: 109px;
  height: 70px;
  border-right-color: #f0f0f0;
  border-top-color: #f0f0f0;
  border-left: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  border-right-style: solid;
  border-top-style: solid;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
._1qdtjegd {
  font-family: PingFangSC-Regular, -apple-system, Hiragino Sans GB, Monospaced Number, Helvetica Neue, Helvetica, Arial, sans-serif;
  width: 1104px;
  margin: 55px auto 30px;
  position: relative;
  font-size: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: #fff;
}
.header {
  height: 79px;
  top: 0;
}
.top-right .user-login {
  float: left;
  height: 100%;
  line-height: 60px;
  font-size: 13px;
  color: #697081;
  margin-right: 22px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  padding-top: 10px;
}
#app {
  background: none !important;
}
._29gnuiyG ._35_vygsc h1 {
  color: #fff !important;
}
.header {
  height: 79px !important;
  top: 0 !important;
}
.top-right .user-login {
  display: flex !important;
  align-items: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/vip.vue